import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { getLatestInsertions, LocalInsertion } from "@/services/insertionsTracker";

const LatestInsertions: React.FC = () => {
  const [insertions, setInsertions] = useState<LocalInsertion[]>([]);

  useEffect(() => {
    // Carica inserimenti iniziali
    setInsertions(getLatestInsertions());

    // Ascolta nuovi inserimenti
    const handleNewInsertion = () => {
      setInsertions(getLatestInsertions());
    };

    window.addEventListener('insertion-added', handleNewInsertion);
    
    return () => {
      window.removeEventListener('insertion-added', handleNewInsertion);
    };
  }, []);

  // Return placeholder with min-height when empty to prevent CLS
  if (insertions.length === 0) {
    return <div className="min-h-[20px]" />;
  }

  return (
    <section className="w-full max-w-4xl mx-auto px-4 mb-4 min-h-[120px]" aria-labelledby="latest-insertions-heading">
      <div className="bg-card/50 backdrop-blur-sm rounded-lg p-3 border border-border/50">
        <h3 id="latest-insertions-heading" className="text-xs font-semibold text-muted-foreground mb-3 flex items-center gap-1">
          <Clock className="w-3 h-3" aria-hidden="true" />
          Ultimi inserimenti cashback
        </h3>
        
        {/* Grid 5 colonne x 2 righe - fixed height to prevent CLS */}
        <div className="grid grid-cols-5 gap-1.5 min-h-[80px]">
          {insertions.slice(0, 10).map((insertion, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center p-1.5 bg-background/80 rounded-md border border-border/30 hover:border-primary/50 transition-colors h-[48px]"
            >
              {/* Nome promo sopra - più piccolo, 2 righe */}
              <span 
                className="text-[9px] leading-tight font-medium text-foreground w-full mb-0.5 line-clamp-2" 
                title={insertion.promoName}
              >
                {insertion.promoName}
              </span>
              {/* Provincia sotto */}
              <span className="text-[10px] text-muted-foreground truncate w-full" title={insertion.province}>
                {insertion.province}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LatestInsertions;
